import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { IEmployee } from '../../model/employee'
import { EmployeeListComponent } from '../employee-list/employee-list.component';
import { EmployeeService } from '../../services/employee.service';
import { NgModule } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, FormControl, Validators, } from '@angular/forms'


@Component({
  selector: 'app-edit-staff',
  templateUrl: './edit-staff.component.html',
  styleUrls: ['./edit-staff.component.scss']
})
export class EditStaffComponent implements OnInit {
  public formSubmitAttempt: boolean;
  registertionImage: string;// = require("../../../assets/images/profile.jpg");
  files: FileList;
  documentfiles: File;
  dob;
  signupForm: FormGroup;
  FirstName: string = "";
  LastName: string = "";
  Email: string = "";
  Password: string = "";
  confirmPassword: string = ""
  currencyType: string = "Kenya Shillings – KES"
  private countryCode: string;
  private homecountryCode: string;
  private workcountryCode: string;
  private setmobile: string;
  private sethome: string;
  private setwork: string;
  EditForm: FormGroup;
  selectedDoctor: IEmployee;
  isSlide: boolean = false;
  constructor(private _employeeService: EmployeeService, private router: Router, private fb: FormBuilder) {
    this.EditForm = fb.group({
      firstName: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.minLength(1)])],
      lastName: ['', [Validators.required, Validators.maxLength(19)]],
      email: ['', [
        //Validators.required,
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$")
      ]],
      mobile: ['', [Validators.required, Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9+]+")]],
      home: ['', [Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9+]+")]],
      work: ['', [Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9+]+")]],
      specialityYear: [],
      degreeDesignation: [],
      currentRegistration: [],
      registrationNumber: [],
      licensingBody: [],
      yearRegistered: [],
      city: [],
      speciality: [],
      //dob:[],
      documentfiles: [],
      institution: [],
      specialInterest: [],
      imagefile: [],
      currencyType: [],
      consultationcharges: [],
      countrycode: [],
      homecountrycode: [],
      workcountrycode: [],
      password: ['', [
        //Validators.required,
        Validators.minLength(8),
        Validators.maxLength(30)
      ]],
      confirmPassword: [''],
    })

  }

  ngOnInit() {
    this.selectedDoctor = this._employeeService.getEmpleeData();
    if (this.selectedDoctor) {
      this.countryCode = (this.selectedDoctor.countryCode == '' || this.selectedDoctor.countryCode == null) ? "254" : this.selectedDoctor.countryCode
      this.homecountryCode = (this.selectedDoctor.homeCountryCode == '' || this.selectedDoctor.homeCountryCode == null) ? "254" : this.selectedDoctor.homeCountryCode
      this.workcountryCode = (this.selectedDoctor.workcountryCode == '' || this.selectedDoctor.workcountryCode == null) ? "254" : this.selectedDoctor.workcountryCode

      this.setmobile = (this.selectedDoctor.mobile == null || this.selectedDoctor.mobile == '') ? null : ("+" + ((this.selectedDoctor.countryCode == '' || this.selectedDoctor.countryCode == null) ? "254" : this.selectedDoctor.countryCode) + this.selectedDoctor.mobile)
      this.sethome = (this.selectedDoctor.home == null || this.selectedDoctor.home == '') ? null : ("+" + ((this.selectedDoctor.homeCountryCode == '' || this.selectedDoctor.homeCountryCode == null) ? "254" : this.selectedDoctor.homeCountryCode) + this.selectedDoctor.home)
      this.setwork = (this.selectedDoctor.work == null || this.selectedDoctor.work == '') ? null : ("+" + ((this.selectedDoctor.workcountryCode == '' || this.selectedDoctor.workcountryCode == null) ? "254" : this.selectedDoctor.workcountryCode) + this.selectedDoctor.work)
      this.EditForm.controls['firstName'].setValue(this.selectedDoctor.firstName);
      this.EditForm.controls['lastName'].setValue(this.selectedDoctor.lastName);
      this.EditForm.controls['email'].setValue(this.selectedDoctor.email);
      this.EditForm.controls['mobile'].setValue(this.setmobile);
      this.EditForm.controls['home'].setValue(this.sethome);
      this.EditForm.controls['work'].setValue(this.setwork);
      this.EditForm.controls['specialityYear'].setValue(this.selectedDoctor.specialityYear);
      this.EditForm.controls['degreeDesignation'].setValue(this.selectedDoctor.degreeDesignation);
      this.EditForm.controls['institution'].setValue(this.selectedDoctor.institution);
      this.EditForm.controls['speciality'].setValue(this.selectedDoctor.speciality);
      this.EditForm.controls['currentRegistration'].setValue(this.selectedDoctor.currentRegistration);
      this.EditForm.controls['registrationNumber'].setValue(this.selectedDoctor.registrationNumber);
      this.EditForm.controls['licensingBody'].setValue(this.selectedDoctor.licensingBody);
      this.EditForm.controls['yearRegistered'].setValue(this.selectedDoctor.yearRegistered);
      this.EditForm.controls['specialInterest'].setValue(this.selectedDoctor.specialInterest);
      this.EditForm.controls['city'].setValue(this.selectedDoctor.city);
      this.EditForm.controls['consultationcharges'].setValue(this.selectedDoctor.consultationCharges);
      this.EditForm.controls['currencyType'].setValue(this.selectedDoctor.currencyType);
      this.currencyType = this.selectedDoctor.currencyType;
      this.EditForm.value.id = this.selectedDoctor.id;
    }
    else {
      this.router.navigate(['stafflist']);
    }


  }

  selectCurrency(event) {
    this.currencyType = event;
  }

  onDocumentUpload(event: any) {
    let files = [].slice.call(event.target.files);
    this.documentfiles = files;

  }


  updateEmployee(employeeForm: FormGroup) {
    this.formSubmitAttempt = true;
    employeeForm.value.mobile = (employeeForm.value.mobile == null || employeeForm.value.mobile == "") ? null : (employeeForm.value.mobile.indexOf("+" + this.countryCode) > -1) ? employeeForm.value.mobile.split("+" + this.countryCode)[1] : employeeForm.value.mobile;
    employeeForm.value.home = (employeeForm.value.home == null || employeeForm.value.home == "") ? null : (employeeForm.value.home.indexOf("+" + this.homecountryCode) > -1) ? employeeForm.value.home.split("+" + this.homecountryCode)[1] : employeeForm.value.home;
    employeeForm.value.work = (employeeForm.value.work == null || employeeForm.value.work == "") ? null : (employeeForm.value.work.indexOf("+" + this.workcountryCode) > -1) ? employeeForm.value.work.split("+" + this.workcountryCode)[1] : employeeForm.value.work;
    employeeForm.controls['mobile'].setValue(employeeForm.value.mobile);
    employeeForm.controls['home'].setValue(employeeForm.value.home);
    employeeForm.controls['work'].setValue(employeeForm.value.work);
    employeeForm.value.countrycode = this.countryCode;
    employeeForm.value.homecountrycode = this.homecountryCode;
    employeeForm.value.workcountrycode = this.workcountryCode;
    employeeForm.value.mobile = (employeeForm.value.mobile == null || employeeForm.value.mobile == "") ? null : (employeeForm.value.mobile.indexOf("+" + this.countryCode) > -1) ? employeeForm.value.mobile.split("+" + this.countryCode)[1] : employeeForm.value.mobile;
    employeeForm.value.home = (employeeForm.value.home == null || employeeForm.value.home == "") ? null : (employeeForm.value.home.indexOf("+" + this.homecountryCode) > -1) ? employeeForm.value.home.split("+" + this.homecountryCode)[1] : employeeForm.value.home;
    employeeForm.value.work = (employeeForm.value.work == null || employeeForm.value.work == "") ? null : (employeeForm.value.work.indexOf("+" + this.workcountryCode) > -1) ? employeeForm.value.work.split("+" + this.workcountryCode)[1] : employeeForm.value.work;
    employeeForm.value.usertype = 3;
    employeeForm.value.address = employeeForm.value.city;
    employeeForm.value.nationalId = null;
    employeeForm.value.id = this.selectedDoctor.id;
    employeeForm.value.userid = this.selectedDoctor.id;
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    employeeForm.value.token = loginUser.token;
    if (employeeForm.invalid) {
      return;
    }
    else {
      if (employeeForm.value.password) {
        if (employeeForm.value.confirmPassword) {
          if (employeeForm.value.password.toString().trim() === employeeForm.value.confirmPassword.toString().trim()) {
            //...
          }
          else {
            alert("password and Confirm Password  is not matched");
            return;
          }
        }
        else {
          alert("Confirm Password is required");
          return;
        }
      }
      else {
        employeeForm.value.password = null
      }

      this._employeeService.updateEmployee(employeeForm.value, this.files).subscribe(
        data => {
          if (data.returnCode == 0) {
            this.formSubmitAttempt = false;
            alert("Staff details updated Sucessfully")
            this.router.navigate(['stafflist']);
          }
          else {
            alert(data.returnMsg)
          }
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });
    }
  }


  reset() {
    this.router.navigate(['stafflist']);
    this.formSubmitAttempt = false;
  }


  onFileChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        this.EditForm.get('imagefile').setValue({
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1],
          fieldname: "imagefile"
        })
      };
    }
  }

  telInputObject(obj) {
    console.log(obj);
    obj.intlTelInput('setCountry', 'ke');

  }


  onCountryChange(obj) {
    var oldcountry = this.countryCode
    this.countryCode = obj.dialCode
    this.setmobile = (this.EditForm.value.mobile == null || this.EditForm.value.mobile == "") ? null : (this.EditForm.value.mobile.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.mobile.split("+" + oldcountry)[1] : this.EditForm.value.mobile;
    if (this.setmobile) {
      this.EditForm.controls['mobile'].setValue("+" + obj.dialCode + this.setmobile);
    }
  }

  onMobileTextChange(event: any) {
    var oldcountry = this.homecountryCode;
    this.setmobile = (this.EditForm.value.mobile == null || this.EditForm.value.mobile == "") ? null : (this.EditForm.value.mobile.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.mobile.split("+" + oldcountry)[1] : this.EditForm.value.mobile;
    if (this.setmobile) {
      this.EditForm.controls['mobile'].setValue("+" + this.homecountryCode + this.setmobile);
    }
  };

  onHomeCountryChange(obj) {
    var oldcountry = this.countryCode
    this.homecountryCode = obj.dialCode
    this.sethome = (this.EditForm.value.home == null || this.EditForm.value.home == "") ? null : (this.EditForm.value.home.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.home.split("+" + oldcountry)[1] : this.EditForm.value.home;
    if (this.sethome) {
      this.EditForm.controls['home'].setValue("+" + obj.dialCode + this.sethome);
    }
  }

  onHomeTextChange(event: any) {
    var oldcountry = this.homecountryCode;
    this.sethome = (this.EditForm.value.home == null || this.EditForm.value.home == "") ? null : (this.EditForm.value.home.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.home.split("+" + oldcountry)[1] : this.EditForm.value.home;
    if (this.sethome) {
      this.EditForm.controls['home'].setValue("+" + this.homecountryCode + this.sethome);
    }
  };

  onWorkCountryChange(obj) {
    var oldcountry = this.countryCode
    this.workcountryCode = obj.dialCode
    this.setwork = (this.EditForm.value.work == null || this.EditForm.value.work == "") ? null : (this.EditForm.value.work.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.work.split("+" + oldcountry)[1] : this.EditForm.value.work;
    if (this.setwork) {
      this.EditForm.controls['work'].setValue("+" + obj.dialCode + this.setwork);
    }
  }

  onWorkTextChange(event: any) {
    var oldcountry = this.homecountryCode;
    this.setwork = (this.EditForm.value.work == null || this.EditForm.value.work == "") ? null : (this.EditForm.value.work.indexOf("+" + oldcountry) > -1) ? this.EditForm.value.work.split("+" + oldcountry)[1] : this.EditForm.value.work;
    if (this.setwork) {
      this.EditForm.controls['work'].setValue("+" + this.homecountryCode + this.setwork);
    }
  };

  getNumber(obj) {
    console.log(obj);
  }
  hasError(obj) {
    console.log(obj)
  }

  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/admin/edit-staff/edit-staff.component.ts